

import React, { useState, useContext, useRef, useLayoutEffect, useEffect } from 'react';
import CodesContext from '../Context/CodesContext';

import { useMountEffect, useUpdateEffect, useIntersectionObserver, useLocalStorage } from 'primereact/hooks';
import axios from '../axios';
import { classNames } from "primereact/utils";
import { DataView } from 'primereact/dataview';
import CodeCard from '../Cards/CodeCard';
import LayoutContext from '../Context/LayoutContext';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import CodeAddModal from '../Modals/CodeAddModal';
import CodeEditModal from '../Modals/CodeEditModal';
import CodeDeleteModal from '../Modals/CodeDeleteModal'
import AppContext from '../Context/AppContext';
import CodeExecuteModal from '../Modals/CodeExecuteModal';

const Codes = () => {
    const [codes, setCodes] = useState([]);
    const [skeleton, setSkeleton] = useState(0);
    const [loading, setLoading] = useState(false);

    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [executeModal, setExecuteModal] = useState(false);

    const [currentData, setCurrentData] = useState(null);

    const dataParams = useRef({ offset: 0, limit: 16, count: 0, searchText: "" })
    const lastElementRef = useRef(null);
    const lastElementVisible = useIntersectionObserver(lastElementRef);
    const scrollPosition = useRef(0);
    const networkController = useRef(null)
    const scrollRef = useRef(null)

    const [searchText, setSearchText] = useLocalStorage("", "security.codes.search")

    const { setNavbar } = useContext(LayoutContext)
    const { user } = useContext(AppContext)

    useMountEffect(() => {
        fetchData({ ...dataParams.current }, true);
    });

    useEffect(() => {
        setNavbar(
            <div className='flex gap-2 flex-1 justify-content-end'>
                <div className="p-inputgroup w-full md:max-w-20rem flex-1">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-search"></i>
                    </span>
                    <InputText placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                </div>
                {user.permissions.admin && <Button className="white-space-nowrap" label={"Add Code"} onClick={() => setAddModal(true)} />}
            </div>
        )
    }, [searchText])

    useUpdateEffect(() => {
        if (!lastElementVisible)
            return;

        fetchData({ ...dataParams.current }, true)
    }, [lastElementVisible])

    useUpdateEffect(() => {
        dataParams.current.searchText = searchText

        fetchData({ ...dataParams.current, offset: 0 }, skeleton !== 0)
    }, [searchText]);

    const fetchData = async (params, skeleton = false) => {
        try {
            networkController.current?.abort()
            skeleton ? setSkeleton(params.limit) : setLoading(true)

            networkController.current = new AbortController()
            const response = await axios.get('/codes', { signal: networkController.current.signal, params: params });

            const _codes = [...codes.slice(0, params.offset), ...response.data.data]
            setCodes(_codes)

            dataParams.current = { ...dataParams.current, count: response.data.count, offset: params.offset + response.data.data.length }

            setSkeleton(0)
            setLoading(false)
        } catch (error) {
            if (error?.code === 'ERR_CANCELED') {
                console.log("Request Canceled!");
            } else {
                console.error('Error:', error);
            }
        }
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return <CodeCard data={product} key={index} />
        });

        return (
            <div className="grid grid-nogutter px-2 md:px-3 py-2 md:py-4 relative">
                {(!loading && skeleton === 0) && <span className="absolute hidden md:block" style={{ top: "0.5rem", left: "1.5rem" }}>{dataParams.current.offset} of {dataParams.current.count}</span>}
                {list}
                {(!loading && skeleton === 0) && <div className={classNames("absolute bottom-0 w-1rem h-20rem", lastElementVisible || dataParams.current.count === dataParams.current.offset ? "hidden" : "")} ref={lastElementRef}></div>}
            </div>
        );
    };

    useLayoutEffect(() => {
        scrollRef.current.scrollTo({
            top: scrollPosition.current,
            left: 0,
            behavior: "instant",
        });
    }, [codes]);

    const handleScroll = (event) => {
        scrollPosition.current = event.target.scrollTop
    }

    return (
        <CodesContext.Provider value={{ loading, setEditModal, setDeleteModal, setExecuteModal, setCurrentData }}>
            <div className="flex flex-column flex-auto surface-section overflow-y-scroll overflow-x-hidden relative align-items-center" ref={scrollRef} onScroll={handleScroll}>
                <DataView className="w-full datacontent flex-1 container" value={codes.filter(item => item.admin_only <= user.permissions.admin).concat(Array(skeleton).fill(null))} listTemplate={listTemplate} layout={'grid'} />
            </div>

            {addModal && <CodeAddModal hide={() => setAddModal(false)} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset + 1 })
            }}></CodeAddModal>}
            {editModal && <CodeEditModal hide={() => setEditModal(false)} data={currentData} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></CodeEditModal>}
            {deleteModal && <CodeDeleteModal hide={() => setDeleteModal(false)} data={currentData} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></CodeDeleteModal>}
            {executeModal && <CodeExecuteModal hide={() => setExecuteModal(false)} data={currentData} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></CodeExecuteModal>}
        </CodesContext.Provider>
    );
};

/*
{addModal && <ImageAddModal hide={() => setAddModal(false)} update={(offset) => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset + offset })
            }}></ImageAddModal>}
            {infoModal.visible && <ImageInfoModal modal={infoModal} hide={() => setInfoModal({ visible: false, tabs: infoModal.tabs })} data={currentData}></ImageInfoModal>}
            {editModal && <ImageEditModal hide={() => setEditModal(false)} data={currentData} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></ImageEditModal>}
            {deleteModal && <DeleteModal hide={() => setDeleteModal(false)} data={currentData} type={"images"} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></DeleteModal>}
            {linkModal && <ImageLinkModal hide={() => setLinkModal(false)} data={currentData} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></ImageLinkModal>}
            {duplicateModal && <DuplicateModal hide={() => setDuplicateModal(false)} data={currentData} type={"images"} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset + 1 })
            }}></DuplicateModal>}
            {transferModal && <TransferModal hide={() => setTransferModal(false)} data={currentData} type={"images"} update={() => {
                fetchData({ ...dataParams.current, offset: 0, limit: dataParams.current.offset })
            }}></TransferModal>}
*/

export default Codes;